var map = {
	"./allinc.png": 6342,
	"./allinclusive.png": 1704,
	"./alpereiser.png": 3841,
	"./amisol.png": 9266,
	"./apollo.png": 1652,
	"./lionalpin.png": 6373,
	"./nazar.png": 1361,
	"./norwegianholidays.png": 5176,
	"./sembo.png": 1539,
	"./solfaktor.png": 7484,
	"./test.png": 7153,
	"./ticket.png": 417,
	"./tripx.png": 1179,
	"./tui.png": 2341,
	"./ving.png": 6695,
	"./vingdynamic.png": 1394,
	"./vitalreiser.png": 7291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2596;